export default __webpack_public_path__ + "static/media/shopping-cart.cd4cf36d.svg";